import React from 'react';

interface FormFieldProps {
  children: React.ReactNode;
  className?: string;
  error?: React.ReactNode;
  errorClassName?: string;
  htmlFor?: string;
  label?: React.ReactNode;
  labelClassName?: string;
  labelSuffix?: React.ReactNode;
  style?: React.CSSProperties;
}

const FormField: React.FC<FormFieldProps> = ({
  children,
  className,
  error,
  errorClassName,
  htmlFor,
  label,
  labelClassName,
  labelSuffix,
  style,
}) => (
  <div className={className} style={style}>
    {label ? (
      <label className={labelClassName} htmlFor={htmlFor}>
        {label}
        {labelSuffix}
      </label>
    ) : null}
    {children}
    {error ? <div className={errorClassName ?? 'form-field-error'}>{error}</div> : null}
  </div>
);

export { FormField };
